import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs/operators';

@Component({
    selector: 'app-sub-menu-layout',
    templateUrl: './sub-menu-layout.component.html',
    styleUrls: ['./sub-menu-layout.component.scss'],
    standalone: false
})
export class SubMenuLayoutComponent implements OnInit {
    menuType: string = '';

    constructor(private route: ActivatedRoute, private router: Router) { }

    ngOnInit(): void {
        // Initial check
        this.updateMenuType();

        // Subscribe to router events to handle child route navigation changes if necessary
        // (Though normally the parent layout doesn't reload, the route data might need checking)
        this.router.events.pipe(
            filter(event => event instanceof NavigationEnd)
        ).subscribe(() => {
            this.updateMenuType();
        });
    }

    private updateMenuType(): void {
        // Traverse the route snapshot to find the data
        let currentRoute = this.route.snapshot;
        while (currentRoute.firstChild) {
            if (currentRoute.data && currentRoute.data['menuType']) {
                this.menuType = currentRoute.data['menuType'];
                break;
            }
            currentRoute = currentRoute.firstChild;
        }

        // Also check the current activated route itself if loop finishes
        if (!this.menuType && this.route.snapshot.data['menuType']) {
            this.menuType = this.route.snapshot.data['menuType'];
        }
    }
}
